/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { RespondToAppraisalRequestOneOf } from './RespondToAppraisalRequestOneOf';
import {
    instanceOfRespondToAppraisalRequestOneOf,
    RespondToAppraisalRequestOneOfFromJSON,
    RespondToAppraisalRequestOneOfFromJSONTyped,
    RespondToAppraisalRequestOneOfToJSON,
} from './RespondToAppraisalRequestOneOf';
import type { RespondToAppraisalRequestOneOf1 } from './RespondToAppraisalRequestOneOf1';
import {
    instanceOfRespondToAppraisalRequestOneOf1,
    RespondToAppraisalRequestOneOf1FromJSON,
    RespondToAppraisalRequestOneOf1FromJSONTyped,
    RespondToAppraisalRequestOneOf1ToJSON,
} from './RespondToAppraisalRequestOneOf1';

/**
 * @type RespondToAppraisalRequest
 * 
 * @export
 */
export type RespondToAppraisalRequest = RespondToAppraisalRequestOneOf | RespondToAppraisalRequestOneOf1;

export function RespondToAppraisalRequestFromJSON(json: any): RespondToAppraisalRequest {
    return RespondToAppraisalRequestFromJSONTyped(json, false);
}

export function RespondToAppraisalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RespondToAppraisalRequest {
    if (json == null) {
        return json;
    }
    if (instanceOfRespondToAppraisalRequestOneOf(json)) {
        return RespondToAppraisalRequestOneOfFromJSONTyped(json, true);
    }
    if (instanceOfRespondToAppraisalRequestOneOf1(json)) {
        return RespondToAppraisalRequestOneOf1FromJSONTyped(json, true);
    }

    return {} as any;
}

export function RespondToAppraisalRequestToJSON(json: any): any {
    return RespondToAppraisalRequestToJSONTyped(json, false);
}

export function RespondToAppraisalRequestToJSONTyped(value?: RespondToAppraisalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfRespondToAppraisalRequestOneOf(value)) {
        return RespondToAppraisalRequestOneOfToJSON(value as RespondToAppraisalRequestOneOf);
    }
    if (instanceOfRespondToAppraisalRequestOneOf1(value)) {
        return RespondToAppraisalRequestOneOf1ToJSON(value as RespondToAppraisalRequestOneOf1);
    }

    return {};
}

